(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["book-preview"] && !Shopify.designMode) return;
  try {
    
  class BookPreviewGallery extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.modal = document.getElementById('book-modal-' + this.sectionId);
      if (!this.modal) return;

      this.desktopSlider = this.modal.querySelector('.book-modal__slider--desktop');
      this.mobileSlider = this.modal.querySelector('.book-modal__slider--mobile');
      this.prevBtn = this.modal.querySelector('.book-modal__nav--prev');
      this.nextBtn = this.modal.querySelector('.book-modal__nav--next');
      this.dotsContainer = this.modal.querySelector('.book-modal__dots');

      this.currentIndex = 0;
      this.init();
    }

    getActiveSlider() {
      return window.innerWidth < 750 ? this.mobileSlider : this.desktopSlider;
    }

    getSlides() {
      const slider = this.getActiveSlider();
      return slider ? Array.from(slider.querySelectorAll('.book-modal__slide')) : [];
    }

    buildDots() {
      this.dotsContainer.innerHTML = '';
      const slides = this.getSlides();
      for (let i = 0; i < slides.length; i++) {
        const dot = document.createElement('button');
        dot.className = 'book-modal__dot' + (i === this.currentIndex ? ' active' : '');
        dot.setAttribute('aria-label', 'Go to page ' + (i + 1));
        dot.addEventListener('click', () => this.goTo(i));
        this.dotsContainer.appendChild(dot);
      }
    }

    updateSlider() {
      const slider = this.getActiveSlider();
      const slides = this.getSlides();
      if (!slider || slides.length === 0) return;

      slides.forEach((slide) => {
        slide.style.flex = '0 0 100%';
        slide.style.transform = `translateX(-${this.currentIndex * 100}%)`;
        slide.style.transition = 'transform 0.4s cubic-bezier(0.25, 0.1, 0.25, 1)';
      });

      const dots = this.dotsContainer.querySelectorAll('.book-modal__dot');
      dots.forEach((dot, i) => dot.classList.toggle('active', i === this.currentIndex));

      if (this.prevBtn) this.prevBtn.disabled = this.currentIndex === 0;
      if (this.nextBtn) this.nextBtn.disabled = this.currentIndex >= slides.length - 1;
    }

    goTo(index) {
      const slides = this.getSlides();
      this.currentIndex = Math.max(0, Math.min(index, slides.length - 1));
      this.updateSlider();
    }

    goNext() {
      const slides = this.getSlides();
      if (this.currentIndex < slides.length - 1) this.goTo(this.currentIndex + 1);
    }

    goPrev() {
      if (this.currentIndex > 0) this.goTo(this.currentIndex - 1);
    }

    init() {
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.goPrev());
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.goNext());

      this.modal.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.modal.close();
        else if (e.key === 'ArrowLeft') this.goPrev();
        else if (e.key === 'ArrowRight') this.goNext();
      });

      let touchStartX = 0;
      const handleTouchStart = (e) => (touchStartX = e.changedTouches[0].screenX);
      const handleTouchEnd = (e) => {
        const diff = touchStartX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) this.goNext();
          else this.goPrev();
        }
      };

      if (this.desktopSlider) {
        this.desktopSlider.addEventListener('touchstart', handleTouchStart, { passive: true });
        this.desktopSlider.addEventListener('touchend', handleTouchEnd, { passive: true });
      }
      if (this.mobileSlider) {
        this.mobileSlider.addEventListener('touchstart', handleTouchStart, { passive: true });
        this.mobileSlider.addEventListener('touchend', handleTouchEnd, { passive: true });
      }

      window.addEventListener('resize', () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
          this.currentIndex = 0;
          this.buildDots();
          this.updateSlider();
        }, 150);
      });

      const origShowModal = this.modal.showModal.bind(this.modal);
      this.modal.showModal = () => {
        origShowModal();
        this.currentIndex = 0;
        this.buildDots();
        this.updateSlider();
        document.body.style.overflow = 'hidden';
      };

      this.modal.addEventListener('close', () => (document.body.style.overflow = ''));
      this.modal.addEventListener('click', (e) => {
        if (e.target === this.modal) this.modal.close();
      });

      this.buildDots();
      this.updateSlider();
    }
  }

  if (!customElements.get('book-preview-gallery')) {
    customElements.define('book-preview-gallery', BookPreviewGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
